/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { Schema } from '@jalik/schema'

const TransactionSchema = new Schema({
  id: {
    type: 'number'
  },
  category: {
    type: 'string',
    required: true
  },
  expense: {
    type: 'boolean',
    required: true
  },
  generated: {
    type: 'boolean'
  },
  label: {
    type: 'string',
    required: true,
    maxLength: 1000
  },
  amount: {
    type: 'number',
    required: true
  },
  cps: {
    type: 'number',
    required: true
  },
  vat: {
    type: 'number',
    required: true
  },
  createdAt: {
    type: 'string',
    format: 'datetime'
  },
  paid: {
    type: 'boolean'
    // required: true
  },
  paidAt: {
    type: 'string',
    format: 'datetime'
  },
  dueAt: {
    type: 'string',
    format: 'datetime',
    required: true
  },
  customerId: {
    type: 'number',
    required: true
  },
  estateId: {
    type: 'number'
  },
  interventionId: {
    type: 'number'
  },
  invoiceId: {
    type: 'number'
  },
  leaseId: {
    type: 'number'
  },
  tmpRef: {
    type: 'string'
  }
})

export default TransactionSchema
